'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var mustache = require('mustache');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Disclosure = require('../../../components/Disclosure/Disclosure.js');
var Box = require('../../../../../../../common/components/layout/Box/Box.js');
var ItemDisclosure_module = require('./ItemDisclosure.module.css.js');
var ItemCard = require('./ItemCard/ItemCard.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);

const ItemsDisclosure = _ref => {
  var _shipment$items, _shipment$items2;
  let {
    shipment,
    claimType
  } = _ref;
  const {
    claimsClaimDetailsShipmentsItems,
    claimsClaimDetailsShipmentsItemsHideContent,
    claimsClaimDetailsShipmentsItemsShowContent
  } = nthHookTranslations.useTranslations();
  return /*#__PURE__*/React__default["default"].createElement(Disclosure["default"], {
    id: `items-${shipment.trackingNumber ?? ''}`,
    title: mustache__default["default"].render(claimsClaimDetailsShipmentsItems ?? '', {
      itemsCount: shipment === null || shipment === void 0 ? void 0 : (_shipment$items = shipment.items) === null || _shipment$items === void 0 ? void 0 : _shipment$items.length
    }),
    hideContentText: claimsClaimDetailsShipmentsItemsHideContent ?? '',
    showContentText: claimsClaimDetailsShipmentsItemsShowContent ?? ''
  }, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    as: "ul",
    gap: 8,
    className: ItemDisclosure_module["default"].itemsList
  }, (_shipment$items2 = shipment.items) === null || _shipment$items2 === void 0 ? void 0 : _shipment$items2.map(item => /*#__PURE__*/React__default["default"].createElement(ItemCard["default"], {
    key: item.name,
    item: item,
    claimType: claimType
  }))));
};
var ItemsDisclosure$1 = nthHookTranslations.withTranslationsProvider(ItemsDisclosure, {
  translationKeys: ['claimsClaimDetailsShipmentsItems', 'claimsClaimDetailsShipmentsItemsHideContent', 'claimsClaimDetailsShipmentsItemsShowContent']
});

exports["default"] = ItemsDisclosure$1;
